/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-23 11:32:34
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-26 14:41:29
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelMultiLanguageSelect/MultiLangDropDown/index.tsx
 */
/*
 * Description: Multi language drop down component,
 * Author: Chris
 * CreatedAt: 2021-3-10
 */
import { getI18nFromGeneral } from '@/src/tools/tools';
import React from 'react';

import css from './css.module.less';

import { Icon } from '@/src/tools/icon';
import DropDown from 'src/constrains/DropdownHOC';
import { useSelector, useDispatch } from 'react-redux';
import {
  currentSelectedLanguage,
  getPageLanguageList,
  updateSelectedLanguage,
  isPrimaryLanguage,
} from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { Menu, MenuItem } from 'src/components/Antd';
import { useRouteMatch } from 'react-router-dom';
import { modal } from 'src/utils/Modal';
import {
  urlParamsKey,
  EnumMultiLanguageType,
} from 'src/constrains/SalesChannelMultiLanguageSelect';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const MultiLangDropDown = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    options,
    handleOnConfirm,
    selected,
    onDropDownChange,
    warningBeforeSwitch,
  } = props;
  const _handleOnConfirm = (e) => {
    if (warningBeforeSwitch) {
      modal.error({
        title: getI18nFromGeneral('general.commonHeader.leave_header'),
        content: getI18nFromGeneral('general.commonHeader.leave_content'),
        onCancel: () => {
          onDropDownChange(false);
        },
        onCancelText: getI18n('general.cancel'),
        onOk: () => {
          handleOnConfirm(e);
          onDropDownChange(false);
        },
        okText: 'Leave',
      });
    } else {
      handleOnConfirm(e);
      onDropDownChange(false);
    }
  };
  return (
    <div className={css.container}>
      <Menu onSelect={_handleOnConfirm} selectedKeys={selected}>
        {options.map((menu) => {
          const { value, label, hasError, primary } = menu || {};
          return (
            <MenuItem className={css.subMenu} key={value}>
              <React.Fragment>
                {label} {primary ? '(Primary)' : ''}{' '}
                {hasError && (
                  <Icon type='iconinfo1' className={css.errIconOption} />
                )}
              </React.Fragment>
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

const MultiLangDropDownTrigger = (props: any) => {
  const { className, title, titleHasError, isPrimary } = props;

  return (
    <div className={`${css.mldContainer} ${className}`}>
      {title && (
        <React.Fragment>
          <span className={css.mldTitle}>
            {title} {isPrimary && '(Primary)'}
          </span>
          <Icon type='icondown' />
          {titleHasError && (
            <Icon type='iconinfo1' className={css.errIconTitle} />
          )}
        </React.Fragment>
      )}
    </div>
  );
};

const MultiLang = DropDown(MultiLangDropDownTrigger, MultiLangDropDown);

const SalesChannelDropdown = React.memo((props: any) => {
  const { hasModified, salesChannelUuidKey, customType } = props;
  const match = useRouteMatch();
  const { params }: any = match;
  const { saleChannelUuid } = params;

  let type = customType
    ? customType
    : EnumMultiLanguageType.SalesChannelContent;
  if (params.contentUuid) {
    type = EnumMultiLanguageType.SalesChannelContent;
  } else if (params.salesChannelProductUuid) {
    type = EnumMultiLanguageType.SalesChannelProduct;
  } else if (params.legalPageUuid) {
    type = EnumMultiLanguageType.SalesChannelLegalPage;
  } else if (params.TcUuid) {
    type = EnumMultiLanguageType.SalesChannelTermsCondition;
  } else if (params.collectionsUuid) {
    type = EnumMultiLanguageType.SalesChannelCollection;
  }

  //暂时先这么写，以后要传参数再说吧

  const _key = urlParamsKey[type];

  const d = useDispatch();

  const uuid = params[_key];
  const key = `${uuid}${type}`;

  const selectedLanguage = useSelector(currentSelectedLanguage());

  const result = useSelector(getPageLanguageList(key)) || [];

  const isPrimary = useSelector(isPrimaryLanguage());
  //console.log(result, 'result');
  const options = result.map((i) => {
    const { tag, hasError, primary } = i;
    return { label: tag, value: tag, hasError, primary };
  });

  const hasError = result.filter((i) => i.hasError).length > 0;
  const handleLanguageOnChange = (e) => {
    const { key } = e;

    d(
      updateSelectedLanguage({
        salesChannelUuid: !salesChannelUuidKey
          ? saleChannelUuid
          : params[salesChannelUuidKey],
        selectedLanguage: key,
      }),
    );
  };

  //console.log(options, 'options=======');

  return (
    <MultiLang
      warningBeforeSwitch={hasModified}
      options={options}
      titleHasError={hasError}
      title={selectedLanguage}
      selected={selectedLanguage}
      dropdownProps={{ maxWidth: 300, maxHeight: 500 }}
      handleOnConfirm={handleLanguageOnChange}
      isPrimary={isPrimary}
    />
  );
});

export default SalesChannelDropdown;
